export const contentTableConfig = {
  title: '使用明细',
  propList: [
    {
      prop: 'menu',
      label: '菜单名称',
      minWidth: '80'
    },
    {
      prop: 'module',
      label: '模块名称',
      minWidth: '80'
    },
    {
      prop: 'username',
      label: '访问人',
      minWidth: '80'
    },
    {
      prop: 'totalCount',
      label: '访问次数',
      minWidth: '80',
      sortable: 'custom'
    },
    {
      prop: 'timeSlot',
      label: '统计时段',
      minWidth: '100'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
